// function accordian(){
//   const accordions = document.querySelectorAll(".accordian-wrap");
//   const openAccordion = (accordion) => {
//     const content = accordion.querySelector(".accordian-content");
//     accordion.classList.add("active");
//     content.style.maxHeight = content.scrollHeight + "px";
//   };
//   const closeAccordion = (accordion) => {
//     const content = accordion.querySelector(".accordian-content");
//     accordion.classList.remove("active");
//     content.style.maxHeight = null;
//   };
//   var first_accordian = document.querySelector(".accordian-wrap");
//   if(first_accordian){
//     var first_content = first_accordian.querySelector(".accordian-content");    
//   }
//   if(first_content){
//     first_content.style.maxHeight = first_content.scrollHeight + "px";
//     first_accordian.classList.add("active");
//     console.log("ifffffffffffff");
//   }
//   accordions.forEach((accordion) => {
//     const intro = accordion.querySelector(".accordian-title");
//     const content = accordion.querySelector(".accordian-content");
//     intro.onclick = () => {
//       if (content.style.maxHeight) {
//         closeAccordion(accordion);
//       } else {
//         accordions.forEach((accordion) => closeAccordion(accordion));
//         openAccordion(accordion);
       
//       }
//     };
//   });
// }
// accordian();
// document.addEventListener("shopify:section:load", function(event) {
//   accordian();
// });
function accordian() {
  const accordions = document.querySelectorAll(".accordian-wrap");

  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    // Scroll the accordion into view when opened
    if (screen.width < 992){
    setTimeout(() => {
      accordion.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 300); 
  }
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  const first_accordian = document.querySelector(".accordian-wrap");
  if (first_accordian) {
    const first_content = first_accordian.querySelector(".accordian-content");
    if (first_content) {
      first_content.style.maxHeight = first_content.scrollHeight + "px";
      first_accordian.classList.add("active");
    }
  }

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".accordian-title");
    const content = accordion.querySelector(".accordian-content");
    intro.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((a) => closeAccordion(a));
        openAccordion(accordion);
      }
    };
  });
}

accordian();

document.addEventListener("shopify:section:load", function (event) {
  accordian();
});

const accordians = document.querySelectorAll('.accordian-content');

accordians.forEach(drawer => {
  drawer.addEventListener('wheel', (e) => {
    // allow normal scroll inside sidebar
    e.stopPropagation();
  }, { passive: false });

  drawer.addEventListener('touchstart', (e) => {
    e.stopPropagation();
  }, { passive: false });

  drawer.addEventListener('touchmove', (e) => {
    e.stopPropagation();
  }, { passive: false });
});

